<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="审核状态" prop="reviewerStatus">
        <a-radio-group button-style="solid" v-model="form.reviewerStatus">
          <a-radio-button :value="2"> 审核打回 </a-radio-button>
          <a-radio-button :value="1"> 通过 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="reviewerEply" v-if="form.reviewerStatus == 2">
        <a-input v-model="form.reviewerEply" style="width: 500px" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { addObj } from '@/api/declaration/customer'
export default {
  name: 'CreateForm',
  components: {},
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        reviewerStatus: 1,
        reviewerEply: undefined,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        reviewerStatus: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.open = false
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        reviewerStatus: 1,
        reviewerEply: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd(id) {
      this.form = {
        id: id,
        reviewerStatus: 1,
        reviewerEply: undefined,
      }
      this.open = true
      this.formTitle = '审核'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改维修话术'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          addObj(this.form)
            .then((response) => {
              this.$message.success('审核成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>
